import { getMutualFundSchemeDetail } from './ApiServiceMF';

// Common function to match the fund using scheme_name and return the desired property
const fetchFundPropertyBySchemeName = async (property) => {
  const fundsData = await getMutualFundSchemeDetail();
  const urlSegment = window.location.pathname.split('/').pop();
  const formattedSchemeName = urlSegment.toLowerCase().replace(/[\s_]+/g, '-');

  const matchedFund = fundsData?.find((fund) => {
    const fundSchemeName = fund.scheme_name.toLowerCase().replace(/[\s_]+/g, '-');
    return fundSchemeName === formattedSchemeName;
  });

  return matchedFund ? matchedFund[property] : null;
};

// Function to fetch plan ID
export const fetchPlanId = async () => {
  return await fetchFundPropertyBySchemeName('plan_id');
};

// Function to fetch category ID
export const fetchCategoryId = async () => {
  return await fetchFundPropertyBySchemeName('category_id');
};
